import type { RomanApiError } from "@roman/shared/lib/net/romanApi";
import romanApi from "@roman/shared/lib/net/romanApi";
import type { GoogleLoginRequest, GoogleLoginResponse } from "@roman/shared/types/Google";
import { isWebPlatform } from "@roman/shared/utils/platform";
import useSWRMutation from "swr/mutation";

export const useLoginWithGoogle = (useHandleError: (msg: string) => (err: RomanApiError) => void) => {
  const handleError = useHandleError("Googleでのログインに失敗しました");

  // Use mobile endpoint for mobile platforms
  const isWeb = isWebPlatform();
  const endpoint = isWeb ? "/oauth/google/login" : "/oauth/google/login/mobile";

  // Web uses httpOnly cookies, mobile uses request body tokens
  const fetcher = (url: string, args: { arg: GoogleLoginRequest }) =>
    romanApi.post<GoogleLoginResponse, GoogleLoginRequest>(url, args.arg, {
      withCredentials: isWeb,
    });

  const { trigger } = useSWRMutation(endpoint, (url: string, args: { arg: GoogleLoginRequest }) => fetcher(url, args), {
    onError: (error) => {
      handleError(error);
    },
  });
  return {
    trigger,
  };
};
